import { useState } from 'react';
import { TrendingUp, Menu, X } from 'lucide-react';

interface MarketingHeaderProps {
  onNavigate: (path: string) => void;
  onSignIn: () => void;
  onSignUp: () => void;
}

export function MarketingHeader({ onNavigate, onSignIn, onSignUp }: MarketingHeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <button
              onClick={() => onNavigate('/')}
              className="flex items-center gap-2"
            >
              <div className="w-9 h-9 bg-blue-600 rounded-lg flex items-center justify-center">
                <TrendingUp className="text-white" size={20} />
              </div>
              <span className="text-lg font-bold text-gray-900">TrezoOne</span>
            </button>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => onNavigate('/fonctionnalites')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Fonctionnalités
            </button>
            <button
              onClick={() => onNavigate('/clients')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Clients
            </button>
            <button
              onClick={() => onNavigate('/tarifs')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Tarifs
            </button>
            <button
              onClick={() => onNavigate('/blog')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Blog
            </button>
            <button
              onClick={() => onNavigate('/beta-founders')}
              className="text-blue-600 hover:text-blue-700 font-semibold transition-colors flex items-center gap-1"
            >
              Beta Founders
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">5 mois offerts</span>
            </button>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <button
              onClick={onSignIn}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Se connecter
            </button>
            <button
              onClick={onSignUp}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              S'inscrire
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-700" />
            ) : (
              <Menu className="h-6 w-6 text-gray-700" />
            )}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => {
                onNavigate('/fonctionnalites');
                setMobileMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg font-medium transition-colors"
            >
              Fonctionnalités
            </button>
            <button
              onClick={() => {
                onNavigate('/clients');
                setMobileMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg font-medium transition-colors"
            >
              Clients
            </button>
            <button
              onClick={() => {
                onNavigate('/tarifs');
                setMobileMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg font-medium transition-colors"
            >
              Tarifs
            </button>
            <button
              onClick={() => {
                onNavigate('/blog');
                setMobileMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg font-medium transition-colors"
            >
              Blog
            </button>
            <button
              onClick={() => {
                onNavigate('/beta-founders');
                setMobileMenuOpen(false);
              }}
              className="block w-full text-left px-4 py-2 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg font-semibold transition-colors"
            >
              Beta Founders (5 mois offerts)
            </button>
            <div className="pt-3 border-t border-gray-200 space-y-2">
              <button
                onClick={() => {
                  onSignIn();
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-center px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium transition-colors"
              >
                Se connecter
              </button>
              <button
                onClick={() => {
                  onSignUp();
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors"
              >
                S'inscrire
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
